import React from 'react'
import { connect } from 'react-redux';
import styles from './Appt.module.css'
import { getDateMDYYYY } from '_helpers';

class PatientHomeAppt extends React.Component {

    render() {
        return (
            <div className={styles.appt_wrapper}>
                <div className={styles.spacer}></div>
                <div className={styles.date}>{getDateMDYYYY(this.props.appt.date)}</div>
                <div className={styles.time}>{this.props.appt.time}</div>
                <div className={styles.day}>{this.props.appt.day}</div>
                <div className={styles.type}>{this.props.appt.type}</div>
                <div className={styles.status}>{this.props.appt.status}</div>
                <div className={styles.location}>{this.props.appt.location}</div>
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        appt: state.entities.apptHist[ownprops.id]
    };
}

const connectedPatientHomeAppt = connect(mapStateToProps)(PatientHomeAppt);
export { connectedPatientHomeAppt as PatientHomeAppt };